import { html } from 'fxjs/es';
import { NessCoreTmplS } from '../../../../../Core/S/Tmpl/module/NessCoreTmplS.js';
import { NessCoreConstantS } from '../../../../../Core/S/Constant/module/NessCoreConstantS.js';

export const homeTitle = ({
  link,
  title,
  sub_title,
  title_color = NessCoreConstantS.colors.black,
  sub_title_color = NessCoreConstantS.colors.black,
}) =>
  link
    ? html` <a class="ness-plus-home__title-wrapper" href="${link}">
        <h2 class="ness-plus-home__title">
          <span class="ness-plus-home__title-text" style="color: ${title_color};">${title}</span>
          <span class="ness-plus-home__title-arrow"
            >${NessCoreTmplS.nessRightIcon({ color: title_color })}</span
          >
        </h2>
        ${sub_title
          ? html` <h3 class="ness-plus-home__sub-title" style="color: ${sub_title_color};">${sub_title}</h3>`
          : ''}
      </a>`
    : html`
        <div class="ness-plus-home__title-wrapper">
          <h2 class="ness-plus-home__title">
            <span class="ness-plus-home__title-text" style="color: ${title_color};">${title}</span>
          </h2>
          ${sub_title
            ? html` <h3 class="ness-plus-home__sub-title" style="color: ${sub_title_color};">
                ${sub_title}
              </h3>`
            : ''}
        </div>
      `;
